import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Button, Table, ModalVariables, TopProgress, Label } from "../../../../components";
import {
  Container,
  ButtonsWrapper
} from './styles'
import { icons } from "../../../../icons";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { affiliateService } from "../../../../api";
import { useParams } from "react-router-dom";
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import { useUi } from "../../../../context/ui.context";
import { compareArrays } from "../../../../utils/findIntersection";


type OverviewProps = {
  conversions?:any
}


const Conversions:FC<OverviewProps> = ({conversions: initialConversions}) => {
  const {volumeId} = useParams()
  const {viewAlert} = useUi()
  const [t] = useTranslation()
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [paginationData, setPaginationData] = useState<any>()
  const [conversions, setConversions] = useState<any[]>(initialConversions || [])
  const [loading, setLoading] = useState<boolean>(false)


  const getConversionsData = async (params?: any) => {
    try {
      setLoading(true)
      const response = await affiliateService.getConversions(params)
      const data = response?.data
      
      if (data) {
        setPaginationData({
          count: data.count || 0,
          total_pages: data.total_pages || 0,
          pageNo: data.current_page || 1,
          page_size: data.page_size || 10
        })
        
        const formattedConversions = data.results?.map((transaction: any) => ({
          ...transaction,
          amount: `${parseFloat(transaction.amount).toFixed(2)} ${transaction.currency}`,
          customer_id: transaction.referral?.user?.id || 'N/A',
          country: transaction.referral?.client?.country || transaction.referral?.region || 'unknown',
          created: timeConverterMMDDYYHHMM(transaction.created_at),
          navigate: `/affiliate/conversions/${transaction.id}`,
        })) || []
        
        setConversions(formattedConversions)
      }
    } catch (e: any) {
      console.error('Error fetching conversions:', e)
      viewAlert({
        severity: 'error',
        message: e?.response?.data?.detail || t("ERROR_OCCURRED")
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const params = {
      page: page || 1,
      page_size: pageSize || 10,
      ordering: ordering
    }
    getConversionsData(params)
  }, [page, pageSize, ordering])

  const Columns = [
    {
      title:t("EXTERNAL_ID"),
      key:'id'
    },
    {
      title:t("CREATED_AT"),
      key:'created'
    },
    {
      title:t("CUSTOMER_ID"),
      key:'customer_id'
    },
    {
      title:t("CONVERSION_AMOUNT"),
      key:'amount'
    },
    {
      title:t("COUNTRY"),
      key:'country'
    },
  ]


  return(
    <Container>
      {
        loading ? 
          <TopProgress loading={loading}/>
        : conversions.length === 0 ? 
          <>
            <Typography variant="body">{t("THERE_ARE_NO_CONVERSIONS_YET")}</Typography>
          </>
        :
          <>
            <Table
              columns={Columns}
              rows={conversions}
              paginationData={paginationData}
              hideCheckbox
              updateData={getConversionsData}
              loading={loading}
              customSetPage={setPage}
              customSetPageSize={setPageSize}
              customPageSize={pageSize}
            />
          </>
      }

    </Container>
  )
}

export default Conversions
